
// calculate font size
function setMainFontSize(){
  let fontCoef = window.innerWidth / 1920
  let fontSize = Math.floor(100 * fontCoef)
  $('html').css('font-size', fontSize + '%')
}

if (window.innerWidth > 1920) {
  setMainFontSize()
  window.addEventListener('resize', function(event){
    setMainFontSize()
  });
}

let is_ios = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
if (is_ios) $('body').addClass('is-ios')
let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) $('body').addClass('is-safari')

// full vertical height for mobile devices, working with iphone bars   height: var(--app-height);
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

